<template>
  <div class="grey lighten-4 pa-4" style="min-height: 100vh;">
    <v-container>
      <v-card>
        <v-toolbar flat color="grey darken-3" dark>
          <v-toolbar-title>
            <v-icon left>mdi-shield-account</v-icon>
            Admin General
          </v-toolbar-title>
        </v-toolbar>

        <!-- PC: Tabs -->
        <v-tabs v-if="$vuetify.breakpoint.mdAndUp" v-model="tab" show-arrows
          background-color="grey lighten-4">
          <v-tab v-for="item in sections" :key="item.key" :href="'#' + item.key">
            <v-icon left small>{{ item.icon }}</v-icon>
            {{ item.text }}
          </v-tab>
        </v-tabs>

        <!-- Mobile: Select -->
        <div v-else class="pa-3">
          <v-select v-model="tab" :items="sections" item-text="text" item-value="key"
            outlined dense hide-details prepend-inner-icon="mdi-menu">
          </v-select>
        </div>

        <!-- Contenido -->
        <v-tabs-items v-model="tab">
          <v-tab-item value="roles">
            <roles-admin></roles-admin>
          </v-tab-item>
          <v-tab-item value="roles-crud">
            <roles-crud-admin></roles-crud-admin>
          </v-tab-item>
          <v-tab-item value="empresa">
            <empresa-data></empresa-data>
          </v-tab-item>
          <v-tab-item value="vendedor">
            <vendedor-comp></vendedor-comp>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import RolesAdmin from '@/components/admin/RolesAdmin.vue';
import RolesCrudAdmin from '@/components/admin/RolesCrudAdmin.vue';
import EmpresaData from '@/views/EmpresaDataV.vue';
import VendedorComp from '@/views/tienda/VendedorV.vue';

export default {
  name: 'AdminGeneralHubV',
  components: { RolesAdmin, RolesCrudAdmin, EmpresaData, VendedorComp },
  data() {
    return {
      tab: 'roles',
      sections: [
        { key: 'roles', text: 'Gestión de Roles', icon: 'mdi-account-key' },
        { key: 'roles-crud', text: 'Administrar Roles', icon: 'mdi-shield-edit' },
        { key: 'empresa', text: 'Empresa', icon: 'mdi-domain' },
        { key: 'vendedor', text: 'Vendedor', icon: 'mdi-account-tie' },
      ]
    };
  }
};
</script>
